// Treat relative URLs (resolve to nav's own origin) and absolute URLs on any
// trusted first-party domain as "ours". Used to gate auth-sensitive actions like
// 401 redirects and cross-frame postMessage trust so third-party responses can't
// trigger them.
//
// `app.accesso.ai` rather than the `accesso.ai` apex on purpose: only that
// subtree is delegated to us, and it already covers every host we serve
// (`app.accesso.ai`, `dev.app.accesso.ai`). Trusting the apex would extend this
// allow-list to sibling subdomains across the wider accesso estate that we
// neither control nor need.
const TRUSTED_HOSTS = ["dexibit.com", "dexibit.io", "app.accesso.ai"];

export const isDexibitApi = (url: string | undefined): boolean => {
  if (!url) return false;
  try {
    const parsed = new URL(url, window.location.origin);
    if (parsed.origin === window.location.origin) return true;
    const { hostname } = parsed;
    // Exact match or a subdomain — avoids lookalikes like "evildexibit.com".
    return TRUSTED_HOSTS.some(
      (host) => hostname === host || hostname.endsWith(`.${host}`),
    );
  } catch {
    return false;
  }
};
